import type { AcknowledgementPayloadDTO } from "@/core/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export async function appendAcknowledgement(body: AcknowledgementPayloadDTO) {
  return patientRequestsTyped.append_acknowledgement({ body, context: { showLoader: false } });
}
